import { render, staticRenderFns } from "./received.vue?vue&type=template&id=147d6e7a&scoped=true"
import script from "./received.vue?vue&type=script&lang=js"
export * from "./received.vue?vue&type=script&lang=js"
import style0 from "./received.vue?vue&type=style&index=0&id=147d6e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147d6e7a",
  null
  
)

export default component.exports